import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Buyback from '@/components/buyback';
import settings from '@/settings/index';

export default function SellPhone() {
  const router = useRouter();

  useEffect(() => {
    if (
      !settings.buyback_exist ||
      (settings.buyback_exist && settings.store === 'quista')
    )
      router.push('/buyback/sell-phone');
  }, [router]);

  return (
    <Buyback
      bannerData={{ heading: `SELL YOUR PHONE TODAY` }}
      brand="Your Phone"
      brandShort="Phone"
      title="phone"
      customSEOText={{
        title: 'Sell & Upgrade Your Smartphones',
        description:
          "Sell your Smartphones with Reebelo's stress-free buyback plan. Enjoy quick valuation, free pick-up and the highest payback.",
      }}
    />
  );
}
